var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.modal.visible.value)?_c(_setup.OrderCouponGift,{attrs:{"visible":_setup.modal.visible.value,"data":_setup.innerData},on:{"close":_setup.onClear,"receive":_setup.onReceive,"exchange":_setup.onExchange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }